import { render } from "./NoticeDialog.vue?vue&type=template&id=a1ed5728&scoped=true"
import script from "./NoticeDialog.vue?vue&type=script&lang=js"
export * from "./NoticeDialog.vue?vue&type=script&lang=js"

import "./NoticeDialog.vue?vue&type=style&index=0&id=a1ed5728&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1ed5728"]])

export default __exports__